import React from "react";
import { getRetreatConfig } from '../Constants/RetreatConfig';
import '../Styles/RegistrationAdditionalDetails.scss';

function RegistrationAdditionalDetails({ week, roomType, setRoomType, craftFairTable, setCraftFairTable,
   setSelectedPage, previousPage, nextPage }) {

   // Retreats with nothing to show here are wired around this step by the parent, so this
   // component never has to navigate on its own behalf.
   const config = getRetreatConfig(week);
   const showRoomType = config.hasRoomTypeChoice;
   const showCraftFair = config.craftFair;
   const roomSurcharge = config.roomSurcharge.toFixed(2);
   const deluxeRoomsFull = config.deluxeRoomsFull;

   return (
      <div className="RegistrationAdditionalDetailsContainer">
         <div className="RegistrationAdditionalDetailsContent">
            <div className="RegistrationAdditionalDetailsHeading">
               Additional Details
            </div>

            {showRoomType &&
               <div className="RegistrationAdditionalDetailsRoomType">
                  <div className="RegistrationAdditionalDetailsSubHeading">
                     Room Type
                  </div>
                  <div className="RegistrationAdditionalDetailsRoomTypeOption">
                     <label>
                        <input
                           type="radio"
                           name="roomType"
                           value="standard"
                           checked={roomType === 'standard'}
                           onChange={() => setRoomType('standard')}
                        />
                        Standard Room
                     </label>
                  </div>
                  {deluxeRoomsFull
                     ? <div className="RegistrationAdditionalDetailsRoomTypeNote">
                        Deluxe rooms are full. If you would like to be put on a waiting list, please email registration@billriceranch.org
                     </div>
                     : <div className="RegistrationAdditionalDetailsRoomTypeNote">
                        Selecting a Deluxe Room adds ${roomSurcharge} to your Camp Fee.
                     </div>
                  }
                  <div className="RegistrationAdditionalDetailsRoomTypeOption">
                     <label>
                        <input
                           type="radio"
                           name="roomType"
                           value="deluxe"
                           checked={roomType === 'deluxe'}
                           disabled={deluxeRoomsFull}
                           onChange={() => setRoomType('deluxe')}
                        />
                        Deluxe Room (+${roomSurcharge})
                     </label>
                  </div>
               </div>
            }

            {showCraftFair &&
               <div className="RegistrationAdditionalDetailsCraftFair">
                  <label>
                     <input
                        type="checkbox"
                        checked={craftFairTable === true}
                        onChange={(event) => setCraftFairTable(event.target.checked)}
                     />
                     I would like to participate in the Craft Fair
                  </label>
               </div>
            }

            <div className="RegistrationAdditionalDetailsButtonsContainer">
               <div className="RegistrationAdditionalDetailsButtons">
                  <div className="RegistrationAdditionalDetailsPreviousButton">
                     <button className="prevButton" onClick={() => setSelectedPage(previousPage)}>
                        Previous
                     </button>
                  </div>
                  <div className="RegistrationAdditionalDetailsNextButton">
                     <button className="nextButton" type="button" onClick={() => setSelectedPage(nextPage)}>
                        Next
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default RegistrationAdditionalDetails;
